export const MCM_VIDEO_PREMIUM_TIERS = [
  { max: 2000, price: new Big('449.95'), onsite: 45 },
  { max: 2500, price: new Big('474.95'), onsite: 50 },
  { max: 3000, price: new Big('499.95'), onsite: 55 },
  { max: 3500, price: new Big('524.95'), onsite: 60 },
  { max: 4000, price: new Big('549.95'), onsite: 65 },
  { max: 4500, price: new Big('574.95'), onsite: 70 },
  { max: 5000, price: new Big('599.95'), onsite: 75 },
  { max: 6000, price: new Big('649.95'), onsite: 85 },
  { max: 7000, price: new Big('699.95'), onsite: 95 },
  { max: 8000, price: new Big('749.95'), onsite: 105 },
  { max: 9000, price: new Big('799.95'), onsite: 115 },
  { max: 10000, price: new Big('849.95'), onsite: 125 },
  { max: 11000, price: new Big('899.95'), onsite: 135 },
  { max: 12000, price: new Big('949.95'), onsite: 145 },
];

export const MCM_VIDEO_LUXURY_TIERS = [
  { max: 2000, price: new Big('999.95'), onsite: 90 },
  { max: 2500, price: new Big('1049.95'), onsite: 95 },
  { max: 3000, price: new Big('1099.95'), onsite: 100 },
  { max: 3500, price: new Big('1149.95'), onsite: 105 },
  { max: 4000, price: new Big('1199.95'), onsite: 110 },
  { max: 4500, price: new Big('1249.95'), onsite: 115 },
  { max: 5000, price: new Big('1299.95'), onsite: 120 },
  { max: 6000, price: new Big('1399.95'), onsite: 130 },
  { max: 7000, price: new Big('1499.95'), onsite: 140 },
  { max: 8000, price: new Big('1599.95'), onsite: 150 },
  { max: 9000, price: new Big('1699.95'), onsite: 160 },
  { max: 10000, price: new Big('1799.95'), onsite: 170 },
  { max: 11000, price: new Big('1899.95'), onsite: 180 },
  { max: 12000, price: new Big('1999.95'), onsite: 190 },
];

export const MCM_MATTERPORT_TIERS = [
  { max: 2000, price: new Big('199.95') },
  { max: 2500, price: new Big('224.95') },
  { max: 3000, price: new Big('249.95') },
  { max: 3500, price: new Big('274.95') },
  { max: 4000, price: new Big('299.95') },
  { max: 4500, price: new Big('324.95') },
  { max: 5000, price: new Big('349.95') },
  { max: 6000, price: new Big('399.95') },
  { max: 7000, price: new Big('449.95') },
  { max: 8000, price: new Big('499.95') },
  { max: 9000, price: new Big('549.95') },
  { max: 10000, price: new Big('599.95') },
  { max: 11000, price: new Big('649.95') },
  { max: 12000, price: new Big('699.95') },
];

export const MCM_MATTERPORT_EXTERIOR_TIERS = [
  { max: 2000, price: new Big('299.95') },
  { max: 2500, price: new Big('324.95') },
  { max: 3000, price: new Big('349.95') },
  { max: 3500, price: new Big('374.95') },
  { max: 4000, price: new Big('399.95') },
  { max: 4500, price: new Big('424.95') },
  { max: 5000, price: new Big('449.95') },
  { max: 6000, price: new Big('499.95') },
  { max: 7000, price: new Big('549.95') },
  { max: 8000, price: new Big('599.95') },
  { max: 9000, price: new Big('649.95') },
  { max: 10000, price: new Big('699.95') },
  { max: 11000, price: new Big('749.95') },
  { max: 12000, price: new Big('799.95') },
];

export const MCM_VIDEO_HIGHLIGHT_TIERS = [
  { max: 2000, price: new Big('299.95'), onsite: 30 },
  { max: 2500, price: new Big('324.95'), onsite: 35 },
  { max: 3000, price: new Big('349.95'), onsite: 40 },
  { max: 3500, price: new Big('374.95'), onsite: 45 },
  { max: 4000, price: new Big('399.95'), onsite: 50 },
  { max: 4500, price: new Big('424.95'), onsite: 55 },
  { max: 5000, price: new Big('449.95'), onsite: 60 },
  { max: 6000, price: new Big('499.95'), onsite: 70 },
  { max: 7000, price: new Big('549.95'), onsite: 80 },
  { max: 8000, price: new Big('599.95'), onsite: 90 },
  { max: 9000, price: new Big('649.95'), onsite: 100 },
  { max: 10000, price: new Big('699.95'), onsite: 110 },
  { max: 11000, price: new Big('749.95'), onsite: 120 },
  { max: 12000, price: new Big('799.95'), onsite: 130 },
];

export const MCM_FLOORPLAN_TIERS = [
  { max: 2000, price: new Big('149.95') },
  { max: 2500, price: new Big('162.50') },
  { max: 3000, price: new Big('174.95') },
  { max: 3500, price: new Big('187.50') },
  { max: 4000, price: new Big('199.95') },
  { max: 4500, price: new Big('212.50') },
  { max: 5000, price: new Big('224.95') },
  { max: 6000, price: new Big('249.95') },
  { max: 7000, price: new Big('274.95') },
  { max: 8000, price: new Big('299.95') },
  { max: 9000, price: new Big('324.95') },
  { max: 10000, price: new Big('349.95') },
  { max: 11000, price: new Big('374.95') },
  { max: 12000, price: new Big('399.95') },
];

import { ProviderPublic, ProviderStaticConfig } from '~/lib/model';
import { McmProviderId, McmProviderStaticData } from '~/tenants/mcm/model/McmProvider';
import { Big } from 'big.js';

export const MCM_PHOTOS_BASE_TIERS = [
  { min: 0, max: 2000, minPhotos: 0, maxPhotos: 30, onsite: 40, revenue: 199.95 }, // "Up to 30"
  { min: 2001, max: 2500, minPhotos: 30, maxPhotos: 35, onsite: 45, revenue: 224.95 }, // "30 - 35"
  { min: 2501, max: 3000, minPhotos: 35, maxPhotos: 40, onsite: 50, revenue: 249.95 }, // "35 - 40"
  { min: 3001, max: 3500, minPhotos: 40, maxPhotos: 45, onsite: 55, revenue: 274.95 }, // "40 - 45"
  { min: 3501, max: 4000, minPhotos: 45, maxPhotos: 50, onsite: 60, revenue: 299.95 }, // "45 - 50"
  { min: 4001, max: 4500, minPhotos: 50, maxPhotos: 55, onsite: 65, revenue: 324.95 }, // "50 - 55"
  { min: 4501, max: 5000, minPhotos: 55, maxPhotos: 60, onsite: 70, revenue: 349.95 }, // "55 - 60"
  { min: 5001, max: 6000, minPhotos: 60, maxPhotos: 70, onsite: 80, revenue: 374.95 }, // "60 - 70"
  { min: 6001, max: 7000, minPhotos: 65, maxPhotos: 75, onsite: 90, revenue: 399.95 }, // "65 - 75"
  { min: 7001, max: 8000, minPhotos: 70, maxPhotos: 80, onsite: 100, revenue: 424.95 }, // "70 - 80"
  { min: 8001, max: 9000, minPhotos: 75, maxPhotos: 85, onsite: 110, revenue: 449.95 }, // "75 - 85"
  { min: 9001, max: 10000, minPhotos: 80, maxPhotos: 90, onsite: 120, revenue: 474.95 }, // "80 - 90"
  { min: 10001, max: 11000, minPhotos: 85, maxPhotos: 95, onsite: 130, revenue: 499.95 }, // "85 - 95"
  { min: 11001, max: 12000, minPhotos: 90, maxPhotos: 100, onsite: 140, revenue: 524.95 }, // "90 - 100"
];

export const MCM_PHOTOS_EXTERIOR_TIERS = [
  { max: 2000, price: new Big('74.95'), minPhotos: 10, maxPhotos: 20, onsite: 15 },
  { max: 2500, price: new Big('79.95'), minPhotos: 10, maxPhotos: 20, onsite: 15 },
  { max: 3000, price: new Big('84.95'), minPhotos: 10, maxPhotos: 20, onsite: 20 },
  { max: 3500, price: new Big('89.95'), minPhotos: 10, maxPhotos: 20, onsite: 20 },
  { max: 4000, price: new Big('94.95'), minPhotos: 10, maxPhotos: 20, onsite: 25 },
  { max: 4500, price: new Big('99.95'), minPhotos: 10, maxPhotos: 20, onsite: 25 },
  { max: 5000, price: new Big('104.95'), minPhotos: 15, maxPhotos: 25, onsite: 30 },
  { max: 6000, price: new Big('109.95'), minPhotos: 15, maxPhotos: 25, onsite: 30 },
  { max: 7000, price: new Big('114.95'), minPhotos: 15, maxPhotos: 25, onsite: 35 },
  { max: 8000, price: new Big('119.95'), minPhotos: 15, maxPhotos: 25, onsite: 35 },
  { max: 9000, price: new Big('124.95'), minPhotos: 20, maxPhotos: 30, onsite: 40 },
  { max: 10000, price: new Big('129.95'), minPhotos: 20, maxPhotos: 30, onsite: 40 },
  { max: 11000, price: new Big('134.95'), minPhotos: 20, maxPhotos: 30, onsite: 45 },
  { max: 12000, price: new Big('139.95'), minPhotos: 20, maxPhotos: 30, onsite: 45 },
];

/**
 * The PUBLIC half of each provider's record: what may ship to the browser.
 * Email, phone, addresses and pay live in ./providers.server.ts and are
 * merged into these same objects on the server (tenants/providers.server.ts).
 */
const MCM_PROVIDER_DATA_PUBLIC: Record<McmProviderId, ProviderPublic<McmProviderStaticData & ProviderStaticConfig>> = {
  [McmProviderId.TOM_RUOCCO]: {
    schedule: true,
    first: 'Tom',
    last: 'Ruocco',
    headshot: 'tom.jpg',
    color: '#FF0002',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: true,
    drone_video: true,
    video: true,
    floorplan: true,
    zillow: true,
    matterport: true,
    event: true,
  },
  [McmProviderId.JOYCE_DAYAN]: {
    schedule: true,
    first: 'Joyce',
    last: 'Dayan',
    headshot: 'joyce.jpg',
    color: '#FF25B7',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: false,
    drone_video: false,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: true,
    event: false,
  },
  [McmProviderId.SEAN_FITZGERALD]: {
    schedule: true,
    first: 'Sean',
    last: 'Fitzgerald',
    headshot: 'sean.jpg',
    color: '#FFB153',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: false,
    drone_video: false,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: true,
    event: false,
  },
  [McmProviderId.ANTHONY_PORTO]: {
    schedule: true,
    first: 'Anthony',
    last: 'Porto',
    headshot: 'anthony.jpg',
    color: '#07ECD2',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: true,
    drone_video: true,
    video: true,
    floorplan: true,
    zillow: true,
    matterport: true,
    event: false,
  },
  [McmProviderId.HOWIE_COHEN]: {
    schedule: true,
    first: 'Howie',
    last: 'Cohen',
    headshot: 'howie.jpg',
    color: '#46005C',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: false,
    drone_video: false,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: true,
    event: false,
  },
  [McmProviderId.CHAD_MOONEY]: {
    schedule: true,
    first: 'Chad',
    last: 'Mooney',
    headshot: 'chad.jpg',
    color: '#DDFE52',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: true,
    drone_video: false,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: true,
    event: false,
  },
  [McmProviderId.CHAD_MARTIN]: {
    schedule: true,
    first: 'Chad',
    last: 'Martin',
    headshot: 'chad.jpg',
    color: '#EB5128',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: true,
    drone_video: true,
    video: true,
    floorplan: true,
    zillow: true,
    matterport: true,
    event: false,
  },
  [McmProviderId.ERICA_YELO]: {
    schedule: true,
    first: 'Erica',
    last: 'Yelo',
    headshot: 'erica.jpg',
    color: '#4395A5',
    location: 'ap',
    travel_start: '10:00',
    photos: true,
    drone_stills: true,
    drone_video: false,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: false,
    event: false,
  },
  [McmProviderId.JACQUELINE_SOKOLOFF]: {
    schedule: true,
    first: 'Jacqueline',
    last: 'Sokoloff',
    headshot: 'jacqueline.jpg',
    color: '#5837AB',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: true,
    drone_video: false,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: false,
    event: false,
  },
  [McmProviderId.DYLAN_JONES]: {
    schedule: true,
    first: 'Dylan',
    last: 'Jones',
    headshot: 'dylan.jpg',
    color: '#D78371',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: true,
    drone_video: true,
    video: true,
    floorplan: true,
    zillow: true,
    matterport: true,
    event: false,
  },
  [McmProviderId.STEPHEN_MORAUX]: {
    schedule: true,
    first: 'Stephen',
    last: 'Moraux',
    headshot: 'stephen.jpg',
    color: '#80EC4B',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: true,
    drone_video: true,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: true,
    event: false,
  },
  [McmProviderId.NADIA_ITANI]: {
    schedule: true,
    first: 'Nadia',
    last: 'Itani',
    headshot: 'nadia.jpg',
    color: '#245696',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: false,
    drone_video: false,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: false,
    event: false,
  },
  [McmProviderId.DAN_GILLESPIE]: {
    schedule: true,
    first: 'Dan',
    last: 'Gillespie',
    headshot: 'dan.jpg',
    color: '#B14221',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: false,
    drone_video: false,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: false,
    event: false,
  },
  [McmProviderId.LARRY_BERKO]: {
    schedule: true,
    first: 'Larry',
    last: 'Berko',
    headshot: 'larry.jpg',
    color: '#C73361',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: false,
    drone_video: false,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: false,
    event: false,
  },
  [McmProviderId.KIMBERLY_PETERS]: {
    schedule: true,
    first: 'Kimberly',
    last: 'Peters',
    headshot: 'kimberly.jpg',
    color: '#C56025',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: false,
    drone_video: false,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: false,
    event: false,
  },
  [McmProviderId.STANTON_HUNTER]: {
    schedule: true,
    first: 'Stanton',
    last: 'Hunter',
    headshot: 'stanton.jpg',
    color: '#48392D',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: false,
    drone_video: false,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: false,
    event: false,
  },
  [McmProviderId.JOE_PERRI]: {
    schedule: true,
    first: 'Joe',
    last: 'Perri',
    headshot: 'joe.jpg',
    color: '#C73361',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: true,
    drone_video: true,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: false,
    event: false,
  },
  [McmProviderId.TADHG_BRADY]: {
    schedule: true,
    first: 'Tadhg',
    last: 'Brady',
    headshot: 'tadhg.jpg',
    color: '#1E4C41',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: true,
    drone_video: true,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: false,
    event: false,
  },
  // [McmProviderId.KARTHEEK_HEDGE]: {
  //   schedule:true,
  //   first: 'Kartheek',
  //   last: 'Hedge',
  //   headshot: 'kartheek.jpg',
  //   color: '#3B837B',
  //   location: 'ap',
  //   travel_start: '09:00',
  //   photos: true,
  //   drone_stills: false,
  //   drone_video: false,
  //   video: false,
  //   floorplan: true,
  //   zillow: true,
  //   matterport: false,
  //   event: false,
  // },
  [McmProviderId.ADAM_SMITHEIMER]: {
    schedule: true,
    first: 'Adam',
    last: 'Smitheimer',
    headshot: 'adam.jpg',
    color: '#C5EF8E',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: true,
    drone_video: true,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: true,
    event: false,
  },
  [McmProviderId.DAN_FITZPATRICK]: {
    schedule: true,
    first: 'Dan',
    last: 'Fitzpatrick',
    headshot: 'dan.jpg',
    color: '#7C1D4E',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: true,
    drone_video: true,
    video: false,
    floorplan: false,
    zillow: false,
    matterport: false,
    event: false,
  },
  [McmProviderId.BARTLETT_LENTINI]: {
    schedule: true,
    first: 'Bartlett',
    last: 'Lentini',
    headshot: 'bartlett.jpg',
    color: '#B14221',
    location: 'ap',
    travel_start: '11:00',
    photos: true,
    drone_stills: false,
    drone_video: false,
    video: false,
    floorplan: true,
    zillow: true,
    matterport: false,
    event: false,
  },
  // [McmProviderId.KEVIN_NEHRBAUER]: {
  //   schedule:true,
  //   first: 'Kevin',
  //   last: 'Nehrbauer',
  //   headshot: 'kevin.jpg',
  //   color: '#2AA294',
  //   location: 'ap',
  //   travel_start: '09:00',
  //   photos: false,
  //   drone_stills: true,
  //   drone_video: false,
  //   video: false,
  //   floorplan: false,
  //   zillow: false,
  //   matterport: false,
  //   event: false,
  // },
  [McmProviderId.FRANK_ZRINSKY]: {
    schedule: true,
    first: 'Frank',
    last: 'Zrinsky',
    headshot: 'frank.jpg',
    color: '#FF0002',
    location: 'ap',
    travel_start: '09:00',
    photos: true,
    drone_stills: true,
    drone_video: true,
    video: true,
    floorplan: true,
    zillow: true,
    matterport: true,
    event: true,
  },
};

/** Typed whole for the code that reads it; on the client the private fields are absent. */
export const MCM_PROVIDER_DATA = MCM_PROVIDER_DATA_PUBLIC as Record<McmProviderId, McmProviderStaticData & ProviderStaticConfig>;
